<template>
  <div class="collect">
    <!-- <h4>我的收藏</h4> -->
    <h2>我的收藏</h2>
    <div class="tabs">
      <div class="bar-list" :class="'selected' + selectedTab">
        <div
          class="tab-bar"
          :class="selectedTab === item.id ? 'selected' : ''"
          v-for="(item, index) in barList"
          :key="index"
          @click="toggleTab(item)"
        >
          {{ item.text }}
        </div>
      </div>
      <div class="content">
        <!-- 案例 -->
        <slot v-if="selectedTab === 0">
          <h3 class="no-collect" v-if="!(collectCase && collectCase.length > 0)">暂无收藏</h3>
          <div class="list-collect l-c" v-else>
            <el-row type="flex" class="f-list">
              <el-col class="f-item" :span="spanCase" v-for="(item, index) in collectCase" :key="'c'+index">
                <el-row type="flex" class="con">
                  <!-- <a class="course" :href="`/${global.year}/course?aid=${sid}&id=${item.courseId}`" target="_blank"> -->
                  <a class="course" :href="formatHref('/course', {sid: sid, cid: item.courseId})" target="_blank">
                    <el-col>
                      <h5>{{ item.courseTitle }}</h5>
                      <p>
                        <span>{{ global.formatTime(item.courseDate, 'Y.M.D') }}</span>
                        <!-- <span>{{global.getWeek(item.courseDate)}} </span> -->
                        <span>{{ item.courseStartTime }}-{{ item.courseEndTime }}</span>
                      </p>
                    </el-col>
                    <el-col v-for="(lecturer, lindex) in item.lecturers||[]" :key="'c'+index+lindex">
                      <el-row type="flex" class="lecturer">
                        <el-row type="flex" class="thumbs">
                          <img :src="(lecturer.thumbs && global.thumbsUrl(lecturer.thumbs)) || require('../../assets/img/null.jpeg')" alt="">
                        </el-row>
                        <el-col class="info">
                          <p class="name">{{ lecturer.penName || lecturer.name }}</p>
                          <p class="company">{{ global.formatCompany(lecturer.company, lecturer.office, lecturer.position) }}</p>
                        </el-col>
                      </el-row>
                    </el-col>
                  </a>
                </el-row>
              </el-col>
            </el-row>
            <!-- <p style="white-space: break-spaces; word-break: break-word;">{{collectCase}}</p> -->
          </div>
        </slot>
        <!-- 讲师 -->
        <slot v-if="selectedTab === 1">
          <h3 class="no-collect" v-if="!(collectTeacher && collectTeacher.length > 0)">暂无收藏</h3>
          <div class="list-collect l-t" v-else>
            <el-row type="flex" class="f-list">
              <el-col class="f-item" :span="spanTeacher" v-for="(lecturer, index) in collectTeacher" :key="'c'+index">
                <el-row type="flex" class="con">
                  <!-- <a class="lecturer" :href="`/${global.year}/teacher?sid=${sid}&tid=${lecturer.lecturerId}`" target="_blank"> -->
                  <a class="lecturer" :href="formatHref('/teacher', {sid: sid, tid: lecturer.lecturerId})" target="_blank">
                    <el-row class="lecturer">
                      <el-row type="flex" class="thumbs">
                        <img :src="(lecturer.lecturerThumbs && global.thumbsUrl(lecturer.lecturerThumbs)) || require('../../assets/img/null.jpeg')" alt="">
                      </el-row>
                      <el-col class="info">
                        <p class="name">{{ lecturer.lecturerPenName || lecturer.lecturerName }}</p>
                        <p class="company" v-html="global.formatCompany(lecturer.lecturerCompany, lecturer.lecturerOffice, lecturer.lecturerPosition, '<br>')"></p>
                      </el-col>
                    </el-row>
                  </a>
                </el-row>
              </el-col>
            </el-row>
            <!-- <p style="white-space: break-spaces; word-break: break-word;">{{collectTeacher}}</p> -->
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinSession } from '../../mixin'

export default {
  mixins: [mixinSession],
  props: {
    token: {
      type: String,
      default: ''
    },
    sid: {
      type: [Number, String],
      default: ''
    },
    screenw: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      collectList: [],
      selectedTab: 0,
      barList: [
        { text: '我收藏的案例', id: 0 },
        { text: '我收藏的讲师', id: 1 }
      ]
    }
  },
  computed: {
    collectCase () {
      let arr = ((this.collectList && this.collectList.meeting && this.collectList.meeting[this.sid]) || []).filter(item => (item.courseId && item.courseId > 0))
      return arr
    },
    collectTeacher () {
      let arr = ((this.collectList && this.collectList.lecturer) || []).filter(item => (item.lecturerId && item.lecturerId > 0))
      return arr
    },
    spanCase () {
      return this.screenw > 540 ? 12 : 24
      // return 24
    },
    spanTeacher () {
      return this.screenw > 700 ? 6 : (this.screenw > 540 ? 8 : 12)
      // return 24
    }
  },
  // created () {
  //   if (this.token) {
  //     this.getCollect(this.token)
  //   }
  // },
  watch: {
    token: {
      handler (newToken) {
        if (newToken) {
          this.getCollect(newToken)
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleTab (item) {
      this.selectedTab = item.id
    },
    getCollect (token) {
      //
      this.$http
        .jsonp(
          `https://www.msup.com.cn/api/api-common/get-favourite-list-universal?choose=1&token=${token}`
        )
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          console.log(res)
          if (res.status && [200, '200'].includes(res.status) && res.data) {
            this.collectList = res.data
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.collect {
  background: #fff;
  // padding-left: 34px;
  // padding-right: 34px;
  padding: 33px;
  h4 {
    margin-top: 34px;
    // margin-bottom: 0;
    padding-bottom: 11px;
    border-bottom: 2px solid #efefef;
    font-size: 24px;
    font-weight: 500;
    color: #5c5c5c;
  }
  h2 {
    margin-bottom: 25px;
    color: #5c5c5c;
    font-size: 24px;
  }
  .no-collect {
    padding-top: 100px;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .tabs {
    .bar-list {
      border-bottom: 2px solid #efefef;
      display: flex;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        width: 144px;
        height: 5px;
        bottom: 0;
        background: var(--main-color);
        transition: all linear 0.3s;
      }
      .tab-bar {
        padding: 23px 21px;
        color: #999999;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 1px;
        cursor: pointer;
        &.selected {
          color: #333333;
        }
      }
      &.selected0::before {
        left: 0;
      }
      &.selected1::before {
        left: 144px;
      }
    }
    .content {
      .list-collect {
        margin: 0 -5px;
        padding-top: 20px;
        .f-list {
          // display: grid;
          // grid-auto-flow: column;
        }
        .el-row--flex {
          flex-wrap: wrap;
          justify-content: flex-start;
          text-align: left;
          .f-item {
            padding-left: 5px;
            padding-right: 5px;
            padding-bottom: 20px;
            .con {
              width: 100%;
              height: 100%;
              padding: 18px 15px;
              background: #f8f8f8;
              border-radius: 4px;
              &:hover {
                background: #f3f3f3;
              }
            }
            a {
              h5 {
                margin: 0;
                margin-bottom: 15px;
                line-height: 1;
                font-size: 18px;
                font-weight: bold;
                color: #333;
              }
              p {
                margin: 0;
                line-height: 1;
                font-size: 14px;
                font-weight: 400;
                color: #888;
                span {
                  margin-right: 5px;
                }
              }
              .thumbs {
                --width-thumbs: 60px;
                width: calc(var(--width-thumbs) + 6px);
                height: calc(var(--width-thumbs) + 6px);
                min-width: calc(var(--width-thumbs) + 6px);
                min-height: calc(var(--width-thumbs) + 6px);
                overflow: hidden;
                border-radius: 50%;
                border: 3px double var(--main-color);
                img {
                  width: var(--width-thumbs);
                  height: var(--width-thumbs);
                  min-width: var(--width-thumbs);
                  min-height: var(--width-thumbs);
                  object-fit: cover;
                  object-position: center top;
                }
              }
              &.course .lecturer {
                margin-top: 15px;
                flex-wrap: nowrap;
                .info {
                  width: 100%;
                  padding-top: 3px;
                  padding-left: 8px;
                  p {
                    line-height: 20px;
                    &.name {
                      margin-bottom: 3px;
                      font-size: 15px;
                      font-weight: bold;
                      color: #333;
                    }
                    &.company {
                      min-height: 40px;
                    }
                  }
                }
              }
              &.lecturer {
                margin: 0 auto;
                .lecturer {
                  text-align: center;
                  justify-content: center;
                  .thumbs {
                    margin: 0 auto;
                    --width-thumbs: 76px;
                  }
                  .info {
                    padding-top: 5px;
                    p {
                      margin-top: 3px;
                      &.name {
                        line-height: 24px;
                        font-size: 16px;
                        font-weight: bold;
                        color: #333;
                      }
                      &.company {
                        min-height: 60px;
                        line-height: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 767px) {
    padding: 10px 4vw;
    .tabs {
      .bar-list {
        .tab-bar {
          font-size: 16px;
        }
      }
    }
    //
  }
}
</style>



// WEBPACK FOOTER //
// src/componentsNew/center/MyCollect.vue